import React, { useState, useEffect } from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useTranslationStore } from '../store/translationStore';
import toast from 'react-hot-toast';

const SearchBar: React.FC = () => {
  const [contextText, setContextText] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const {
    translate,
    loading,
    searchText,
    setSearchText
  } = useTranslationStore();

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!searchText.trim()) {
      toast.error('Please enter text to translate');
      return;
    }

    await translate(searchText.trim(), contextText.trim());
    setContextText('');
  };

  return (
    <div className="max-w-2xl mx-auto">

      <form onSubmit={handleSearch} className="space-y-4">
        <div className="relative">
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Translate to Chinese"
            className="w-full px-6 py-4 pr-16 text-base border border-gray-200 rounded-xl focus:outline-none focus:border-gray-400 transition-colors placeholder-gray-400"
            disabled={loading}
          />
        </div>

        <div className="relative">
          <input
            type="text"
            value={contextText}
            onChange={(e) => setContextText(e.target.value)}
            placeholder={isMobile ? "Provide context for your word" : "Provide context if your word has multiple meanings, e.g. food, animal..."}
            className="w-full px-6 py-4 text-base border border-gray-200 rounded-xl focus:outline-none focus:border-gray-400 transition-colors placeholder-gray-400"
            disabled={loading}
          />
        </div>

        <button
          type="submit"
          disabled={loading || !searchText.trim()}
          className="w-full py-4 px-6 bg-blue-600 text-white rounded-xl hover:bg-blue-700 disabled:opacity-50 disabled:hover:bg-blue-600 transition-colors font-medium flex items-center justify-center gap-2"
        >
          <MagnifyingGlassIcon className="h-5 w-5" />
          {loading ? 'Translating...' : 'Translate'}
        </button>

      </form>
    </div>
  );
};

export default SearchBar;